/**
 * CF7 Phone Input
 * Restricts CF7 tel fields to phone characters: digits, spaces, - . ( )
 * and a single leading "+". Server-side check lives in functions.php.
 */

const TEL_SELECTOR = '.wpcf7 input[type="tel"]';
const MAX_LENGTH = 20;

function sanitizePhone(value) {
    const cleaned = value.replace(/[^0-9\s\-().+]/g, '').replace(/^\s+/, '');
    const hasLeadingPlus = cleaned.charAt(0) === '+';
    const rest = cleaned.replace(/\+/g, '');

    return ((hasLeadingPlus ? '+' : '') + rest).slice(0, MAX_LENGTH);
}

function handleInput(event) {
    const input = event.target;
    if (!input.matches || !input.matches(TEL_SELECTOR)) return;

    const value = input.value;
    const cleaned = sanitizePhone(value);
    if (cleaned === value) return;

    // Keep the caret where the user was typing
    const caret = input.selectionStart;
    input.value = cleaned;
    if (caret !== null) {
        const newCaret = sanitizePhone(value.slice(0, caret)).length;
        input.setSelectionRange(newCaret, newCaret);
    }
}

export function initCF7PhoneInput() {
    document.querySelectorAll(TEL_SELECTOR).forEach(function(input) {
        input.setAttribute('inputmode', 'tel');
        input.setAttribute('maxlength', String(MAX_LENGTH));
    });

    document.addEventListener('input', handleInput);
}
